/**
 * DetectionPills - Eligible Complaints + Vulnerability detection badges
 *
 * Two pill variants:
 * - Eligible Complaints (berry)
 * - Vulnerability (purple)
 *
 * `showCounts` controls whether counts are displayed (cards: yes, overview header: no).
 *
 * Atomic level: Molecule
 */

import React from 'react';

interface DetectionPillsProps {
  eligibleComplaintsCount?: number;
  vulnerableCustomersCount?: number;
  showCounts?: boolean;
  className?: string;
}

const DetectionPills: React.FC<DetectionPillsProps> = ({
  eligibleComplaintsCount = 0,
  vulnerableCustomersCount = 0,
  showCounts = true,
  className = '',
}) => {
  return (
    <div className={`flex gap-1 flex-wrap ${className}`}>
      <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold px-2 py-0.5 rounded-full border border-[rgba(146,32,77,0.12)] bg-[rgba(146,32,77,0.05)] text-[#92204D]">
        Eligible Complaints
        {showCounts && <span className="font-bold">{eligibleComplaintsCount}</span>}
      </span>
      <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold px-2 py-0.5 rounded-full border border-[rgba(88,0,149,0.12)] bg-[rgba(88,0,149,0.05)] text-[#580095]">
        Vulnerability
        {showCounts && <span className="font-bold">{vulnerableCustomersCount}</span>}
      </span>
    </div>
  );
};

export { DetectionPills };
export type { DetectionPillsProps };
